import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { withTheme } from "emotion-theming"

import Slider from "./slider"
import { Wrapper } from "./styles"

const Slideshow = ({ theme }) => {
  const data = useStaticQuery(graphql`
    query SlideshowQuery {
      allFile(filter: { sourceInstanceName: { eq: "slideshow" } }) {
        edges {
          node {
            id
            publicURL
            relativeDirectory
          }
        }
      }
    }
  `)
  const slides = {
    tall: [],
    medium: [],
    small: [],
    wide: [],
  }
  data.allFile.edges.forEach((slide, _) => {
    slides[slide.node.relativeDirectory].push(slide.node)
  })

  return (
    <Wrapper>
      <div>
        <Slider slides={slides.tall} delay={1000} />
      </div>
      <div>
        <Slider slides={slides.medium} delay={2000} />
      </div>
      <div>
        <Slider slides={slides.small} delay={0} />
      </div>
      <div>
        <Slider slides={slides.wide} delay={3000} />
      </div>
    </Wrapper>
  )
}

export default withTheme(Slideshow)
